// -----------------------------------------------------------------------------
// ConfirmationQuitFormModal.jsx – design uniformisé avec AddAppelOffreForm
// -----------------------------------------------------------------------------
import React from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  IconButton,
  Paper,
  styled,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";

/* ────────────────────────────────────────────────────────────────────────── */
/*  🎨   DESIGN TOKENS – identiques à AddAppelOffreForm                      */
/* ────────────────────────────────────────────────────────────────────────── */
const NAVY       = "#2F4E8B";
const NAVY_LIGHT = "#4a6bad";
const OUTLINE    = "#D4D9E0";
const LABEL_GREY = "#4F5565";

/* ───  Fond dégradé identique aux captures                                   */
const GradientPaper = styled(Paper)({
  borderRadius: 3,
  padding: 24,
  width: "100%",
  maxWidth: 500,
  margin: "0 auto",
  background:
    "linear-gradient(135deg, #FFFFFF 0%, #F6F9FC 60%, #E9F0F9 100%)",
  position: "relative",
});

/**
 * Props:
 *  - open: boolean
 *  - title: string
 *  - message: string
 *  - onClose: (confirm: boolean) => void
 */
const ConfirmationQuitFormModal = ({ open, title, message, onClose }) => {
  return (
    <Modal open={open} onClose={() => onClose(false)}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "90%", sm: 500 },
          outline: "none",
        }}
      >
        <GradientPaper elevation={8}>
          {/* Close icon */}
          <IconButton
            onClick={() => onClose(false)}
            sx={{
              position: "absolute",
              top: 16,
              right: 16,
              color: LABEL_GREY,
            }}
          >
            <CloseIcon />
          </IconButton>

          {/* Title */}
          <Typography
            variant="h6"
            align="center"
            sx={{ fontWeight: 700, color: NAVY, mb: 2 }}
          >
            {title}
          </Typography>

          {/* Message */}
          <Typography
            align="center"
            sx={{ color: LABEL_GREY, mb: 4 }}
          >
            {message}
          </Typography>

          {/* Actions */}
          <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
            <Button
              variant="outlined"
              onClick={() => onClose(false)}
              sx={{
                borderColor: OUTLINE,
                color: LABEL_GREY,
                textTransform: "none",
                px: 4,
                fontWeight: 600,
                borderRadius: 1,
                "&:hover": {
                  backgroundColor: OUTLINE,
                  color: NAVY,
                },
              }}
            >
              Annuler
            </Button>
            <Button
              variant="contained"
              onClick={() => onClose(true)}
              sx={{
                backgroundColor: NAVY,
                color: "#fff",
                textTransform: "none",
                px: 4,
                fontWeight: 600,
                borderRadius: 1,
                "&:hover": {
                  backgroundColor: NAVY_LIGHT,
                },
              }}
            >
              Quitter
            </Button>
          </Box>
        </GradientPaper>
      </Box>
    </Modal>
  );
};

export default ConfirmationQuitFormModal;
